// extracted by mini-css-extract-plugin
export var messageSideLeft = "_n1-1";
export var stateContainer = "_n1-0";